import { useContext } from 'react';
import { TenantContext, tenant } from './tenantContextValue';

export { tenant };

export function useTenant() {
  return useContext(TenantContext);
}
